/// Sign-in / signed-in chrome shown in the home-screen top-right.
///
/// Two states:
///   - Anonymous browser  →  SignInButton opens the unified
///     AuthModal (Google + email/password + forgot password,
///     Apple coming soon).
///   - Real provider      →  SignedInMenu shows display name +
///     a click-to-toggle "Sign out" affordance. Sign-out drops
///     back to a fresh anonymous user.

import { useState } from 'react'
import type { User } from 'firebase/auth'
import { AuthModal } from './AuthModal'
import { useProfileStore } from '../state/profileStore'

export function SignInButton() {
  const [open, setOpen] = useState(false)
  return (
    <>
      <button
        onClick={() => setOpen(true)}
        title="Sign in to save your progress across devices"
        className="flex h-7 items-center gap-1.5 rounded-md bg-emerald-600 px-2.5 text-xs font-semibold text-white shadow ring-1 ring-emerald-400/40 transition-colors hover:bg-emerald-500"
      >
        Sign in
      </button>
      {open && <AuthModal onDismiss={() => setOpen(false)} />}
    </>
  )
}

export function SignedInMenu(props: { user: User }) {
  const signOut = useProfileStore((s) => s.signOut)
  const [open, setOpen] = useState(false)
  const label = props.user.displayName || props.user.email || 'Signed in'
  return (
    <div className="relative">
      <button
        onClick={() => setOpen((v) => !v)}
        title={props.user.email ?? undefined}
        className="flex h-7 items-center gap-1.5 rounded-md bg-slate-900/70 px-2.5 text-xs font-semibold text-white/90 shadow ring-1 ring-white/10 hover:bg-slate-800/80"
      >
        {props.user.photoURL ? (
          <img
            src={props.user.photoURL}
            alt=""
            className="h-4 w-4 rounded-full"
            referrerPolicy="no-referrer"
          />
        ) : (
          <span className="text-[10px]">●</span>
        )}
        <span className="max-w-[140px] truncate">{label}</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-1 w-40 rounded-md bg-slate-900 py-1 text-xs text-white/90 shadow-lg ring-1 ring-white/10">
          <button
            onClick={() => {
              setOpen(false)
              void signOut()
            }}
            className="block w-full px-3 py-1.5 text-left hover:bg-white/5"
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  )
}

